import './css/LButton.css'
import {luiCheckAllowedValues, luiClassName} from "../../utils/lui"
import PropTypes from "prop-types"


/**
 *   Типовая Кнопка
 *
 *  @param {JSX.Element|string} children Контент кнопки
 *  @param {string} title Title
 *  @param {string} name Имя для идентификации
 *  @param {string} size Размер: 'small', '', 'large'
 *  @param {string} variant Вариант (см. стили _LButton_ )
 *  @param {*} type Тип: 'submit', 'reset'
 *  @param {string} shape Форма: null, 'round', 'square'
 *  @param {boolean} disabled Отключена
 *  @param {string} className Добавочный класс
 *  @param {*} style Добавочный стиль
 *  @param {?function(e)} onClick Колбэк
 *  @returns {JSX.Element}
 *  @constructor
 */
export default function LButton ({
    children='', title, name,
    size, variant, type='button',
    shape, disabled,
    className='', style,
    onClick=null
}){
    // Проверка допустимых значений
    luiCheckAllowedValues({ component: 'LButton', allowed: _allowed, values: arguments[0] })

    // Класс
    const classFin = luiClassName([
        '_LButton_',
        className,
        variant && variant,
        size && `s-${size}`,
        shape && shape,
    ])

    // Вывод
    return (
        <button
            name={name}
            onClick={onClick}
            className={classFin}
            title={title}
            disabled={disabled}
            type={type}
            style={style}
        >
            {children}
        </button>
    )
}

/**
 *  Список допустимых значений
 */
const _allowed = {
    size:       [ 'small', 'large' ],
    type:       [ 'submit', 'reset', 'button' ],
    shape:      [ 'round', 'square' ],
    variant:    [
        'primary', 'secondary', 'surface',
        'outline', 'outline-secondary', 'outline-surface',
        'text', 'text-secondary', 'text-surface'
    ]
}


LButton.propTypes = {
    name:       PropTypes.string,
    title:      PropTypes.string,
    size:       PropTypes.oneOf(_allowed.size),
    variant:    PropTypes.oneOf(_allowed.variant),
    type:       PropTypes.oneOf(_allowed.type),
    shape:      PropTypes.oneOf(_allowed.shape),
    disabled:   PropTypes.bool,
    className:  PropTypes.string,
    style:      PropTypes.object,
    onClick:    PropTypes.func
}